// extracted by mini-css-extract-plugin
module.exports = {"container":"spinner_container__2PEFQ","spinner":"spinner_spinner__rNRrs"};